import type { QueryKey } from "@tanstack/react-query";

const ROW_ACTION_MUTATION_KEY = "providerOperationsAction";

/** Matches every row action, because mutation keys are matched by prefix. */
export const PROVIDER_OPERATIONS_ROW_ACTION_MUTATION_KEY: QueryKey = [ROW_ACTION_MUTATION_KEY];

export const PROVIDER_OPERATIONS_BULK_ACTION_MUTATION_KEY: QueryKey = ["providerOperationsBulkAction"];

export function createGameRowActionMutationKey(gameId: number): QueryKey {
	return [ROW_ACTION_MUTATION_KEY, gameId];
}
